import React from 'react';
import Reveal from './Reveal';
import { photos } from '../photos';

export default function Problems({ t }) {
  const p = t.problems;

  return (
    <section className="bg-snow bg-grid py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-stretch">
        <Reveal className="lg:col-span-5">
          <div className="relative h-full min-h-[420px] overflow-hidden bg-pine">
            <img src={photos.gym} alt={t.media.gym} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-snow">
              <p className="font-display text-xs tracking-[0.28em] uppercase text-volt">02</p>
              <p className="font-display text-4xl uppercase leading-none mt-2 tracking-tight">{p.kicker}</p>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7 flex flex-col justify-center">
          <Reveal>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92] tracking-tight">
              {p.title}
            </h2>
            <p className="mt-5 text-lg text-stone max-w-xl leading-relaxed">{p.sub}</p>
          </Reveal>

          <div className="mt-10 border-t border-ink/15">
            {p.items.map((item, i) => (
              <Reveal key={item.title} delay={i * 70}>
                <div className="grid grid-cols-[auto_1fr] gap-5 sm:gap-8 py-6 border-b border-ink/15">
                  <span className="font-display text-3xl text-voltDeep leading-none">0{i + 1}</span>
                  <div>
                    <h3 className="font-display text-2xl uppercase tracking-wide">{item.title}</h3>
                    <p className="mt-2 text-stone leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
